

























import { Component, Vue, Prop } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import { IsValidExternalPath } from '../../../core';
import NavBarLink from './NavBarLink.layout.vue';
import NavBarAccount from './NavBarAccount.layout.vue';
import { RouteConfig } from 'vue-router';

@Component({
  name: 'NavBarList',
  components: {
    NavBarLink,
    NavBarAccount,
  },
})
export default class NavBarList extends BaseComponent {
  @Prop() items?: RouteConfig[];

  // for external values
  // private resolvePath(routePath: string) {
  //   if (IsValidExternalPath(routePath)) {
  //     return routePath;
  //   }
  // }

  // private logout() {
  //   JwtStorageService.removeToken();
  //   toast.success('로그아웃 성공적으로 했습니다.');
  //   this.$router.push('/login');
  // }

  private activeRoutes() {
    return this.items.filter(item => {
      console.log(item, 'item');
    });
  }
}
